/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentDetail } from '../../models/content-detail';

export interface GetContent$Params {

/**
 * ID obsahu
 */
  id: number;

/**
 * ID sekcie
 */
  sectionId?: number;
}

export function getContent(http: HttpClient, rootUrl: string, params: GetContent$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDetail>> {
  const rb = new RequestBuilder(rootUrl, getContent.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('sectionId', params.sectionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentDetail>;
    })
  );
}

getContent.PATH = '/client/content/{id}';
